import { createSlice } from '@reduxjs/toolkit';
import commonState from '../states/commonState';
import { setCommonState, setUserRoles } from '../actions/commonActions';
import camelize from 'camelize';

export const commonSlice = createSlice({
  name: 'common',
  initialState: commonState,
  reducers: {},
  extraReducers: (builder) => {
    // just allow ad hoc data in the common store
    builder.addCase(setCommonState, (state, action) => ({
      ...state,
      ...action.payload,
    }));
    builder.addCase(setUserRoles, (state, action) => ({
      ...state,
      userRoles: camelize(action.payload),
    }));
  },
});
